var _circle, _g, _path, _path2, _path3, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _path10, _g3, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallCardSkeleton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 171,
    viewBox: "0 0 249 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 122.5,
    cy: 85.5,
    r: 85,
    fill: "#EBEBEB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2294_42619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.499 65H234.249C235.907 65 237.497 65.6585 238.669 66.8306C239.841 68.0027 240.5 69.5924 240.5 71.25V102.5C240.5 104.158 239.841 105.747 238.669 106.92C237.497 108.092 235.907 108.75 234.249 108.75H65.499C63.8414 108.75 62.2517 108.092 61.0796 106.92C59.9075 105.747 59.249 104.158 59.249 102.5V71.25C59.249 69.5924 59.9075 68.0027 61.0796 66.8306C62.2517 65.6585 63.8414 65 65.499 65V65Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.5005 79C85.5005 76.7909 87.2913 75 89.5005 75H105.25C107.46 75 109.25 76.7909 109.25 79V94.75C109.25 96.9591 107.46 98.75 105.25 98.75H89.5005C87.2913 98.75 85.5005 96.9591 85.5005 94.75V79Z",
    fill: "#C7C7C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2137 90.012H90.8074L93.3678 82.7393H94.9942L97.5581 90.012H96.1519L94.2094 84.2307H94.1526L92.2137 90.012ZM92.2598 87.1604H96.0951V88.2187H92.2598V87.1604Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5161 90.012V82.7393H101.3C101.826 82.7393 102.263 82.8221 102.611 82.9878C102.961 83.1512 103.223 83.3749 103.395 83.659C103.571 83.9431 103.658 84.2651 103.658 84.6249C103.658 84.9208 103.601 85.1742 103.488 85.3849C103.374 85.5932 103.221 85.7625 103.03 85.8927C102.838 86.0229 102.624 86.1164 102.387 86.1732V86.2442C102.645 86.2584 102.892 86.3377 103.129 86.4822C103.368 86.6242 103.563 86.8254 103.715 87.0858C103.866 87.3463 103.942 87.6611 103.942 88.0305C103.942 88.4069 103.851 88.7454 103.669 89.0461C103.486 89.3444 103.212 89.5799 102.845 89.7528C102.478 89.9256 102.016 90.012 101.46 90.012H98.5161ZM99.8335 88.9111H101.25C101.729 88.9111 102.073 88.82 102.284 88.6377C102.497 88.453 102.603 88.2163 102.603 87.9275C102.603 87.712 102.55 87.5179 102.444 87.3451C102.337 87.1699 102.186 87.0326 101.989 86.9331C101.793 86.8314 101.558 86.7805 101.286 86.7805H99.8335V88.9111ZM99.8335 85.8323H101.137C101.364 85.8323 101.569 85.7909 101.751 85.708C101.933 85.6228 102.077 85.5032 102.181 85.3493C102.287 85.1931 102.341 85.0084 102.341 84.7954C102.341 84.5136 102.241 84.2816 102.042 84.0993C101.846 83.9171 101.553 83.8259 101.165 83.8259H99.8335V85.8323Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M157.501 75H125C122.929 75 121.25 76.6789 121.25 78.75C121.25 80.8211 122.929 82.5 125 82.5H157.501C159.572 82.5 161.251 80.8211 161.251 78.75C161.251 76.6789 159.572 75 157.501 75Z",
    fill: "#E0E0E1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M180.001 91.25H125C122.929 91.25 121.25 92.9289 121.25 95C121.25 97.0711 122.929 98.75 125 98.75H180.001C182.072 98.75 183.751 97.0711 183.751 95C183.751 92.9289 182.072 91.25 180.001 91.25Z",
    fill: "#EBEBEB"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2294_42619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7505 118.75H180.501C182.159 118.75 183.748 119.408 184.92 120.581C186.092 121.753 186.751 123.342 186.751 125V156.25C186.751 157.908 186.092 159.497 184.92 160.67C183.748 161.842 182.159 162.5 180.501 162.5H11.7505C10.0929 162.5 8.50318 161.842 7.33108 160.67C6.15897 159.497 5.50049 157.908 5.50049 156.25V125C5.50049 123.342 6.15897 121.753 7.33108 120.581C8.50318 119.408 10.0929 118.75 11.7505 118.75V118.75Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5005 132.5C31.5005 130.291 33.2913 128.5 35.5005 128.5H51.2505C53.4596 128.5 55.2505 130.291 55.2505 132.5V148.25C55.2505 150.459 53.4596 152.25 51.2505 152.25H35.5005C33.2913 152.25 31.5005 150.459 31.5005 148.25V132.5Z",
    fill: "#C7C7C7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5528 138.984C41.5197 138.674 41.38 138.433 41.1338 138.26C40.89 138.087 40.5727 138.001 40.1821 138.001C39.9075 138.001 39.6719 138.042 39.4754 138.125C39.2789 138.208 39.1286 138.32 39.0244 138.462C38.9203 138.604 38.867 138.767 38.8646 138.949C38.8646 139.1 38.899 139.232 38.9676 139.343C39.0386 139.454 39.1345 139.549 39.2553 139.627C39.376 139.703 39.5098 139.767 39.6565 139.819C39.8033 139.871 39.9513 139.915 40.1004 139.95L40.7822 140.121C41.0569 140.185 41.3208 140.271 41.5742 140.38C41.8298 140.489 42.0583 140.626 42.2595 140.792C42.4631 140.958 42.6241 141.158 42.7425 141.392C42.8608 141.627 42.92 141.901 42.92 142.216C42.92 142.642 42.8111 143.017 42.5933 143.342C42.3755 143.664 42.0607 143.916 41.6487 144.098C41.2392 144.278 40.7432 144.368 40.1608 144.368C39.595 144.368 39.1037 144.28 38.6871 144.105C38.2728 143.93 37.9484 143.674 37.7141 143.338C37.4821 143.002 37.3566 142.592 37.3376 142.109H38.6338C38.6528 142.363 38.7309 142.573 38.8682 142.742C39.0055 142.91 39.1842 143.035 39.4044 143.118C39.6269 143.201 39.8755 143.242 40.1501 143.242C40.4366 143.242 40.6876 143.2 40.903 143.114C41.1208 143.027 41.2912 142.906 41.4144 142.752C41.5375 142.596 41.6002 142.414 41.6026 142.205C41.6002 142.016 41.5446 141.86 41.4357 141.737C41.3268 141.611 41.1741 141.507 40.9776 141.424C40.7834 141.339 40.5562 141.263 40.2957 141.197L39.4683 140.984C38.8694 140.83 38.3959 140.597 38.0479 140.284C37.7022 139.969 37.5294 139.551 37.5294 139.031C37.5294 138.602 37.6454 138.227 37.8774 137.905C38.1118 137.583 38.4302 137.333 38.8327 137.156C39.2351 136.976 39.6909 136.886 40.1999 136.886C40.716 136.886 41.1681 136.976 41.5564 137.156C41.947 137.333 42.2536 137.581 42.4761 137.898C42.6987 138.213 42.8135 138.575 42.8206 138.984H41.5528Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.047 138.984C48.0138 138.674 47.8742 138.433 47.628 138.26C47.3841 138.087 47.0669 138.001 46.6762 138.001C46.4016 138.001 46.1661 138.042 45.9696 138.125C45.7731 138.208 45.6227 138.32 45.5186 138.462C45.4144 138.604 45.3611 138.767 45.3588 138.949C45.3588 139.1 45.3931 139.232 45.4618 139.343C45.5328 139.454 45.6287 139.549 45.7494 139.627C45.8701 139.703 46.0039 139.767 46.1507 139.819C46.2975 139.871 46.4454 139.915 46.5946 139.95L47.2764 140.121C47.551 140.185 47.815 140.271 48.0683 140.38C48.324 140.489 48.5524 140.626 48.7537 140.792C48.9573 140.958 49.1182 141.158 49.2366 141.392C49.355 141.627 49.4142 141.901 49.4142 142.216C49.4142 142.642 49.3053 143.017 49.0875 143.342C48.8697 143.664 48.5548 143.916 48.1429 144.098C47.7333 144.278 47.2373 144.368 46.6549 144.368C46.0891 144.368 45.5979 144.28 45.1812 144.105C44.7669 143.93 44.4426 143.674 44.2082 143.338C43.9762 143.002 43.8507 142.592 43.8318 142.109H45.128C45.1469 142.363 45.225 142.573 45.3623 142.742C45.4996 142.91 45.6784 143.035 45.8985 143.118C46.1211 143.201 46.3697 143.242 46.6443 143.242C46.9307 143.242 47.1817 143.2 47.3971 143.114C47.6149 143.027 47.7854 142.906 47.9085 142.752C48.0316 142.596 48.0943 142.414 48.0967 142.205C48.0943 142.016 48.0387 141.86 47.9298 141.737C47.8209 141.611 47.6682 141.507 47.4717 141.424C47.2776 141.339 47.0503 141.263 46.7899 141.197L45.9625 140.984C45.3635 140.83 44.89 140.597 44.542 140.284C44.1964 139.969 44.0235 139.551 44.0235 139.031C44.0235 138.602 44.1396 138.227 44.3716 137.905C44.6059 137.583 44.9244 137.333 45.3268 137.156C45.7293 136.976 46.185 136.886 46.694 136.886C47.2101 136.886 47.6623 136.976 48.0505 137.156C48.4412 137.333 48.7477 137.581 48.9703 137.898C49.1928 138.213 49.3076 138.575 49.3147 138.984H48.047Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M103.501 128.5H71.0005C68.9294 128.5 67.2505 130.179 67.2505 132.25C67.2505 134.321 68.9294 136 71.0005 136H103.501C105.572 136 107.251 134.321 107.251 132.25C107.251 130.179 105.572 128.5 103.501 128.5Z",
    fill: "#E0E0E1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M126.001 144.75H71.0005C68.9294 144.75 67.2505 146.429 67.2505 148.5C67.2505 150.571 68.9294 152.25 71.0005 152.25H126.001C128.072 152.25 129.751 150.571 129.751 148.5C129.751 146.429 128.072 144.75 126.001 144.75Z",
    fill: "#EBEBEB"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2294_42619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.501 11.25H11.7505C8.29872 11.25 5.50049 14.0482 5.50049 17.5V48.7501C5.50049 52.2019 8.29872 55.0001 11.7505 55.0001H180.501C183.953 55.0001 186.751 52.2019 186.751 48.7501V17.5C186.751 14.0482 183.953 11.25 180.501 11.25Z",
    fill: "white"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5005 25.25C31.5005 23.0409 33.2913 21.25 35.5005 21.25H51.2505C53.4596 21.25 55.2505 23.0409 55.2505 25.25V41C55.2505 43.2091 53.4596 45 51.2505 45H35.5005C33.2913 45 31.5005 43.2091 31.5005 41V25.25Z",
    fill: "#C7C7C7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7882 36.761H36.382L38.9423 29.4883H40.5687L43.1327 36.761H41.7264L39.7839 30.9798H39.7271L37.7882 36.761ZM37.8344 33.9094H41.6696V34.9677H37.8344V33.9094Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0245 36.761H43.6183L46.1787 29.4883H47.8051L50.369 36.761H48.9627L47.0203 30.9798H46.9635L45.0245 36.761ZM45.0707 33.9094H48.9059V34.9677H45.0707V33.9094Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M103.501 21.25H71.0006C68.9295 21.25 67.2505 22.9289 67.2505 25C67.2505 27.0711 68.9295 28.75 71.0006 28.75H103.501C105.572 28.75 107.251 27.0711 107.251 25C107.251 22.9289 105.572 21.25 103.501 21.25Z",
    fill: "#E0E0E1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M126.001 37.5H71.0006C68.9295 37.5 67.2505 39.1789 67.2505 41.25C67.2505 43.3211 68.9295 45 71.0006 45H126.001C128.072 45 129.751 43.3211 129.751 41.25C129.751 39.1789 128.072 37.5 126.001 37.5Z",
    fill: "#EBEBEB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2294_42619",
    x: 57.249,
    y: 63,
    width: 191.25,
    height: 53.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.230539 0 0 0 0 0.370572 0 0 0 0 0.482993 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2294_42619"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2294_42619",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2294_42619",
    x: 0.500488,
    y: 116.75,
    width: 191.25,
    height: 53.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.230539 0 0 0 0 0.370572 0 0 0 0 0.482993 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2294_42619"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2294_42619",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2294_42619",
    x: 0.500488,
    y: 9.25,
    width: 191.25,
    height: 53.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.230539 0 0 0 0 0.370572 0 0 0 0 0.482993 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2294_42619"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2294_42619",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallCardSkeleton);
export default __webpack_public_path__ + "static/media/small-card-skeleton.ca7d8d64da36a77541067466d7fbc8ff.svg";
export { ForwardRef as ReactComponent };